import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] text-white font-mono flex items-center justify-center p-6">
      <div className="max-w-md w-full border border-zinc-800 bg-[#0d0d0d] p-10 text-center">
        <XCircle className="mx-auto text-zinc-500 mb-6" size={48} />
        <h1 className="font-display text-3xl tracking-tight mb-2">CHECKOUT CANCELLED</h1>
        <p className="text-sm text-zinc-400 mb-8">No charge was made. You can upgrade anytime.</p>
        <button
          onClick={() => navigate("/studio")}
          data-testid="cancel-back-btn"
          className="w-full bg-volt text-black py-3 text-sm font-bold uppercase tracking-widest hover:bg-volt-hover transition-colors duration-100"
        >
          Back to Studio
        </button>
      </div>
    </div>
  );
}
